(function () {
  'use strict';

  angular.module('app').component('bookingTotalsTable', bookingTotalsTable());

  function bookingTotalsTable() {
    return {
      bindings: {
        booking: '<',
      },
      controller: BookingTotalsTableComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/components/booking-totals-table/booking-totals-table.component.html',
    };
  }

  function BookingTotalsTableComponent() {}
})();
